import { LogoLayout } from '@/components/layout/Layout';
import { SimpleFooter } from '@/components/layout/SimpleFooter';
import TimeOutContent from '@/components/simple-terms/TimeOutContent';

const ErrorPage = () => {
  return <TimeOutContent />;
};

ErrorPage.getLayout = (page: React.ReactNode) => {
  return <LogoLayout footerContent={<SimpleFooter />}>{page}</LogoLayout>;
};

export default ErrorPage;
